import {drawer} from '@cypro/ui/components'
import {PatientTherapySequenceDrawer, PatientTherapySequenceDrawerProps} from '@/modules/patients-therapies/components'
import {PatientTherapySequenceProvider} from '@/shared/contexts/patient-therapy-sequence-context'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {Suspense} from 'react'

export function getPatientTherapySequenceDrawerId(sequenceId: string) {
  return `sequence-drawer-${sequenceId}`
}

export function openPatientTherapySequenceDrawer(
  sequence: PatientTherapySequence,
  drawerProps?: PatientTherapySequenceDrawerProps
) {
  return openPatientTherapySequenceDrawerInternal(sequence.id, drawerProps)
}

export function openPatientTherapySequenceDrawerById(
  sequenceId: string,
  drawerProps?: PatientTherapySequenceDrawerProps
) {
  return openPatientTherapySequenceDrawerInternal(sequenceId, drawerProps)
}

function openPatientTherapySequenceDrawerInternal(sequenceId: string, drawerProps?: PatientTherapySequenceDrawerProps) {
  const id = getPatientTherapySequenceDrawerId(sequenceId)
  return drawer.open(id, {
    id,
    children: (
      <Suspense>
        {sequenceId && (
          <PatientTherapySequenceProvider key={sequenceId} sequenceId={sequenceId}>
            <PatientTherapySequenceDrawer {...drawerProps} />
          </PatientTherapySequenceProvider>
        )}
      </Suspense>
    ),
    blockInverseIndex: true,
    hideCloseTrigger: true,
    size: 'full',
    contentProps: {
      'data-e2e': 'patient-therapy-sequence-drawer',
      maxWidth: '3xl',
      justifyContent: 'space-between',
    },
  })
}
